import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: ReactNode;
  adminOnly?: boolean;
}

function ProtectedRoute({ children, adminOnly = false }: ProtectedRouteProps) {
  if (!sessionStorage.getItem('token')) {
    return <Navigate to="/login" replace />;
  }
  if (adminOnly && sessionStorage.getItem('is_admin') !== '1') {
    return <Navigate to="/access-denied" replace />;
  }
  return <>{children}</>;
}

export default ProtectedRoute;
